<div class="row">
  <uni-card class="col-md-4 desktop-cards-container" *ngFor="let group of cardsGroup">
    <uni-list *ngFor="let item of group" gap="none" bullet="none">
      <uni-list-item
        [inlineTitle]="inlineTitle ?? (item.inlineTitle === undefined ? true : item.inlineTitle)"
        [title]="item.title"
        >{{ item.description }}</uni-list-item
      >
    </uni-list>
  </uni-card>
  <div class="mobile-card-container col-sm-12">
    <uni-card>
      <div *ngFor="let group of cardsGroup" class="row mobile-row">
        <uni-list *ngFor="let item of group" class="mb-2 ml-2" gap="none" bullet="none">
          <uni-list-item [inlineTitle]="item.inlineTitle === undefined ? true : item.inlineTitle" [title]="item.title">{{
            item.description
          }}</uni-list-item>
        </uni-list>
      </div>
    </uni-card>
  </div>
</div>
